export enum ResellersTab {
  Overview = 'overview',
  TrialCredits = 'trial-credits',
  Credits = 'credits',
}

export const RESELLERS_TABS_TRANSLATED = {
  [ResellersTab.Overview]: 'Overview',
  [ResellersTab.TrialCredits]: 'Trial Credits',
  [ResellersTab.Credits]: 'Credits',
};
